"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var typescript_fsa_1 = __importDefault(require("typescript-fsa"));

var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");

var actionCreator = typescript_fsa_1.default();
var actions = {
  start: actionCreator('START'),
  succeed: actionCreator('SUCCESS'),
  fail: actionCreator('FAILURE'),
  reset: actionCreator('RESET')
};
exports.INITIAL_ASYNC_STATE = {
  isPending: false,
  isDone: false
};
var reducer = typescript_fsa_reducers_1.reducerWithInitialState(exports.INITIAL_ASYNC_STATE).case(actions.start, function () {
  return {
    isPending: true,
    isDone: false,
    error: undefined
  };
}).case(actions.succeed, function (state) {
  return _objectSpread({}, state, {
    isPending: false,
    isDone: true
  });
}).case(actions.fail, function (_, error) {
  return {
    isPending: false,
    isDone: false,
    error: error
  };
}).case(actions.reset, function () {
  return _objectSpread({}, exports.INITIAL_ASYNC_STATE, {
    error: undefined
  });
});

var useAsyncState = function useAsyncState() {
  var _react_1$useReducer = react_1.useReducer(reducer, exports.INITIAL_ASYNC_STATE),
      _react_1$useReducer2 = _slicedToArray(_react_1$useReducer, 2),
      state = _react_1$useReducer2[0],
      dispatch = _react_1$useReducer2[1];

  var dispatchStartAction = react_1.useCallback(function () {
    dispatch(actions.start());
  }, []);
  var dispatchSuccessAction = react_1.useCallback(function () {
    dispatch(actions.succeed());
  }, []);
  var dispatchFailureAction = react_1.useCallback(function (error) {
    dispatch(actions.fail(error));
  }, []);
  var dispatchResetAction = react_1.useCallback(function () {
    dispatch(actions.reset());
  }, []);
  return {
    state: state,
    dispatchStartAction: dispatchStartAction,
    dispatchSuccessAction: dispatchSuccessAction,
    dispatchFailureAction: dispatchFailureAction,
    dispatchResetAction: dispatchResetAction
  };
};

exports.default = useAsyncState;